module.exports = __webpack_public_path__ + "img/section2b_3.096e4c65.png";